import { NgModule, inject } from '@angular/core';
import { ROUTES, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TermsAndConditionsModule } from '@fgb/portal-component-library/src/lib/club/terms-and-conditions';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { RegistrationTermsAndConditionsComponent } from './registration-terms-and-conditions/registration-terms-and-conditions.component';
import { RegistrationQuestionsComponent } from './registration-questions/registration-questions.component';
import { RegistrationOptOutEmailsComponent } from './registration-opt-out-emails/registration-opt-out-emails.component';
import { RegistrationOptOutAlertsComponent } from './registration-opt-out-alerts/registration-opt-out-alerts.component';
import { RegistrationOperatorNameComponent } from './registration-operator-name/registration-operator-name.component';
import { RegistrationPartnerInviteComponent } from './registration-partner-invite/registration-partner-invite.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { RegistrationProviderOauthComponent } from './registration-provider-oauth/registration-provider-oauth.component';
import { RegistrationProviderTranslationComponent } from './registration-provider-translation/registration-provider-translation.component';
import { RegistrationAddChildrenComponent } from './registration-add-children/registration-add-children.component';
import {
  MembershipOptionPipe,
  RegistrationMembershipOptionsComponent,
} from './registration-membership-options/registration-membership-options.component';
import { RegistrationChooseMembershipOptionTypeComponent } from './registration-choose-membership-option-type/registration-choose-membership-option-type.component';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationPersonalDetailsComponent } from './registration-personal-details/registration-personal-details.component';
import { DateSelectModule } from '@fgb/portal-component-library/src/lib/shared/date-select';
import { CountryAndRegionsModule } from '@fgb/portal-component-library/src/lib/shared/country-and-regions';
import { RegistrationChildQuestionsComponent } from './registration-child-questions/registration-child-questions.component';
import { RegistrationGetProviderDetailsComponent } from './registration-get-provider-details/registration-get-provider-details.component';
import { RegistrationEntryPageComponent } from './pages/registration-entry-page/registration-entry-page.component';
import { RegistrationFailurePageComponent } from './pages/registration-failure-page/registration-failure-page.component';
import { RegistrationSuccessPageComponent } from './pages/registration-success-page/registration-success-page.component';
import { RegistrationWizardDisabledPageComponent } from './pages/registration-wizard-disabled-page/registration-wizard-disabled-page.component';
import { RegistrationPaymentCallbackPageComponent } from './pages/registration-payment-callback-page/registration-payment-callback-page.component';
import { RegistrationShippingAddressComponent } from './registration-shipping-address/registration-shipping-address.component';
import { RegistrationReferAFriendPageComponent } from './registration-refer-a-friend/registration-refer-a-friend.component';
import { RegistrationPaymentComponent } from './registration-payment/registration-payment.component';
import { RegistrationProviderAuthenticationComponent } from './registration-provider-authentication/registration-provider-authentication.component';
import { ModelMetaDataFormModule } from '@fgb/portal-component-library/src/lib/shared/forms/model-meta-data-form';
import { RegistrationNavigationModule } from './registration-navigation/registration-navigation.module';
import { RegistrationMarketingPlaceholderComponent } from './registration-marketing-placeholder/registration-marketing-placeholder.component';
import { SelectCountryModule } from '@fgb/portal-component-library/src/lib/shared/select-country';
import { TicketMasterIconComponent } from './login-providers/icons/ticket-master-icon.component';
import { TmLoginButtonComponent } from './login-providers/tm-login-button/tm-login-button.component';
import { SelectRegionModule } from '@fgb/portal-component-library/src/lib/shared/select-region';
import { REGISTRATION_ROUTES } from '@fgb/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { RegistrationSelectCustomerMembershipOptionComponent } from './registration-select-membership-option/registration-select-membership-option.component';
import { RegistrationBenefitOptionsComponent } from './registration-benefits/registration-benefits-options.component';
import { RegistrationAccountVerificationComponent } from './registration-account-verification/registration-account-verification.component';
import { ExpressCheckoutComponent } from '@fgb/portal-component-library/src/lib/shared/payment/express-checkout';

@NgModule({
  declarations: [
    RegistrationTermsAndConditionsComponent,
    RegistrationQuestionsComponent,
    RegistrationOptOutEmailsComponent,
    RegistrationOptOutAlertsComponent,
    RegistrationOperatorNameComponent,
    RegistrationPartnerInviteComponent,
    RegistrationProviderOauthComponent,
    RegistrationProviderTranslationComponent,
    RegistrationAddChildrenComponent,
    RegistrationMembershipOptionsComponent,
    RegistrationSelectCustomerMembershipOptionComponent,
    RegistrationChooseMembershipOptionTypeComponent,
    RegistrationPersonalDetailsComponent,
    RegistrationChildQuestionsComponent,
    RegistrationGetProviderDetailsComponent,
    RegistrationEntryPageComponent,
    RegistrationFailurePageComponent,
    RegistrationSuccessPageComponent,
    RegistrationWizardDisabledPageComponent,
    RegistrationPaymentCallbackPageComponent,
    RegistrationShippingAddressComponent,
    RegistrationProviderAuthenticationComponent,
    RegistrationPaymentComponent,
    RegistrationMarketingPlaceholderComponent,
    RegistrationReferAFriendPageComponent,
    RegistrationBenefitOptionsComponent,
    TicketMasterIconComponent,
    TmLoginButtonComponent,
    MembershipOptionPipe,
  ],
  imports: [
    CommonModule,
    TermsAndConditionsModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorsModule,
    LoadingModule,
    DateSelectModule,
    CountryAndRegionsModule,
    NgbModule,
    FGBSharedModule,
    PipesModule,
    RouterModule,
    ModelMetaDataFormModule,
    RegistrationNavigationModule,
    SelectCountryModule,
    SelectRegionModule,
    RegistrationAccountVerificationComponent,
    ExpressCheckoutComponent,
  ],
  exports: [
    RegistrationTermsAndConditionsComponent,
    RegistrationQuestionsComponent,
    RegistrationOptOutEmailsComponent,
    RegistrationPersonalDetailsComponent,
    RegistrationChildQuestionsComponent,
    RegistrationGetProviderDetailsComponent,
    RegistrationOptOutAlertsComponent,
    RegistrationOperatorNameComponent,
    RegistrationProviderOauthComponent,
    RegistrationProviderTranslationComponent,
    RegistrationAddChildrenComponent,
    RegistrationMembershipOptionsComponent,
    RegistrationSelectCustomerMembershipOptionComponent,
    RegistrationChooseMembershipOptionTypeComponent,
    RegistrationTermsAndConditionsComponent,
    RegistrationPartnerInviteComponent,
    RegistrationQuestionsComponent,
    RegistrationOptOutEmailsComponent,
    RegistrationEntryPageComponent,
    RegistrationFailurePageComponent,
    RegistrationSuccessPageComponent,
    RegistrationWizardDisabledPageComponent,
    RegistrationPaymentCallbackPageComponent,
    RegistrationShippingAddressComponent,
    RegistrationProviderAuthenticationComponent,
    RegistrationPaymentComponent,
    RegistrationMarketingPlaceholderComponent,
    RegistrationReferAFriendPageComponent,
    RegistrationBenefitOptionsComponent,
    TicketMasterIconComponent,
    TmLoginButtonComponent,
    RegistrationAccountVerificationComponent,
    RouterModule,
  ],
  providers: [
    {
      provide: ROUTES,
      useFactory: () => inject(REGISTRATION_ROUTES),
    },
  ],
})
export class RegistrationModule {}
